import React from 'react';
import {AutoComplete, Button, Form, Input, Modal, notification} from "antd";
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";

import ApiService from "../../../../services/ApiService";
import {EsriProvider} from 'leaflet-geosearch';

const provider = new EsriProvider();

export default class ModalEditRoute extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        contact: null,
        adresseId: null,
        edit: false,
        defaultData: {},
        routes: []
    };

    state = this.initialState;

    async initRoutes() {
        var res = await ApiService.get("/contact/routes");
        console.log(res);

        if (res.success) {
            this.setState({routes: res.items});
        }
    }

    async show(contact, adresseId = "MAIN", route = null) {
        this.initRoutes();
        if (route) {
            this.setState({
                visible: true,
                contact: contact,
                adresseId: adresseId,
                defaultData: {route: route},
                edit: true
            });
        } else {
            this.setState({visible: true, contact: contact, adresseId: adresseId});
        }
    }

    componentDidMount() {
        this.initRoutes();
    }

    close() {
        this.setState(this.initialState);
    }

    async onSubmit(data) {
        console.log(data);

        if (!data.route || data.route?.trim() === "") {
            data.route = null;
        }

        this.setState({loading: true});

        var res = await ApiService.post("/contact/route/edit/" + this.state.contact + "/" + this.state.adresseId, data);
        console.log(res);

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Modification réussie` : t`Ajout réussi`
            });

            this.close();
            if (this.props.onFinish) {
                this.props.onFinish(res.route);
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de l'édition` : t`Erreur lors de l'ajout`
            });
        }

        this.setState({loading: false});
    }

    render() {
        return (
            <Modal
                width="100%"
                title={<Trans>Modifier la Route</Trans>}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >

                <Form
                    ref={(ref) => this.form = ref}
                    initialValues={this.state.defaultData}
                    onFinish={(data) => this.onSubmit(data)}
                >
                    <Form.Item
                        label={<Trans>Route</Trans>}
                        name="route"
                    >
                        <AutoComplete
                            allowClear
                            options={this.state.routes.map((r) => ({
                                value: r,
                                label: r
                            }))}
                            filterOption={(inputValue, option) =>
                                option?.label?.toLowerCase()?.includes(inputValue.toLowerCase())
                            }
                            placeholder={t`Créer une nouvelle route ou choisissez une route existante`}
                        />
                    </Form.Item>

                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>
        )
    }
}
